import { V3Button } from "../Button"
import { LearnMoreCTA } from "../ReusableStyledComponents/LearnMoreCTA"
import { RightAlignPanel } from "../ReusableStyledComponents/RightAlignPanel"
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35"
import { V3HeadlineH5 } from "../Typography"
import { V3CopyToClipboard } from "../V3CopyToClipobard"
import { V3ModalBase } from "../V3ModalBase"
import { VerticalSpacing } from "../VerticalSpacing"

interface V3RSSDetailsProps {
    url: string,
    target?: string,
    sharingEnabled: boolean,
    modalOpen: boolean,
    setModalOpen: (open: boolean) => void,
    unavailableMessage?: string,
}

export const V3RSSDetails = ({ url, target = "portfolio", sharingEnabled, modalOpen, setModalOpen, unavailableMessage }: V3RSSDetailsProps) => <V3ModalBase
    onClose={() => setModalOpen(false)}
    isOpen={modalOpen}
    title="Create RSS feed"
>
    {
        sharingEnabled ? <>
            <VerticalSpacing bottom={18}>
                <V3CaptionGrey35>Use the RSS feed of your {target} anywhere. <LearnMoreCTA href="https://authory.com/help/en/articles/6389093-how-does-the-rss-feed-work" /></V3CaptionGrey35>
            </VerticalSpacing>
            <VerticalSpacing bottom={12}>
                <V3HeadlineH5>RSS Link</V3HeadlineH5>
            </VerticalSpacing>
            <V3CopyToClipboard
                url={url}
                trimProtocol={false}
            />
        </>
            : <>
                <VerticalSpacing bottom={18}>
                    <V3CaptionGrey35>{unavailableMessage ?? (target === "portfolio" ? "In order to use this feature, please publish your portfolio first." : "In order to use this feature, please enable sharing.")}</V3CaptionGrey35>
                </VerticalSpacing>
            </>
    }
    <RightAlignPanel>
        <div>
            <V3Button
                text="Close"
                onClick={() => setModalOpen(false)}
            />
        </div>
    </RightAlignPanel>
</V3ModalBase>